import React, { Fragment, useContext, useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { paginationComponentOptions } from "../../../Shared/Constants/DatatableConstants";

import TableButtons from "../../../Shared/Components/TableButtons";
import { provincesColums } from "../Data/ProvincesListColums";
import { deleteConfirmationModal } from "../../../Shared/Components/DeleteConfrimationModal";
import ProvinceContext from "../Context/Index";

const TableProvincesComponent = () => {
  const {
    items,
    setRowsPerPage,
    setCurrentPage,
    currentPage,
    loading,
    rowsPerPage,
    deleteItem,
    totalRows,
    setItem,
    modalTogle,
    fetchItems,
    searchTerm,
  } = useContext(ProvinceContext);

  const [colums, setColums] = useState([]);

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Handle rows per page change
  const handleRowsPerPageChange = (newPerPage) => {
    setRowsPerPage(newPerPage);
    setCurrentPage(1); // Reset to first page
  };

  const handleDelete = (row) => {
    deleteConfirmationModal(row.id, deleteItem);
  };
  const handleEdit = async (row) => {
    console.log("row", row);

    setItem(row);
    modalTogle();
  };

  useEffect(() => {
    setColums([
      ...provincesColums,
      {
        name: "Acciones",
        width: "200px",
        cell: (row) => (
          <TableButtons
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            row={row}
            entity={"list"}
          ></TableButtons>
        ),
        ignoreRowClick: true, // Prevent action buttons from triggering row selection
        allowOverflow: true, // Prevent layout overflow issues
        button: true, // Indicate that it's a button column
      },
    ]);
  }, [items]);
  useEffect(() => {
    fetchItems(currentPage, rowsPerPage);
  }, [currentPage, searchTerm]);

  return (
    <Fragment>
      <DataTable
        data={items}
        columns={colums}
        striped={true}
        center={true}
        pagination
        paginationServer // Enables server-side pagination
        paginationTotalRows={totalRows} // Pass total rows to DataTable
        paginationComponentOptions={paginationComponentOptions}
        paginationDefaultPage={currentPage} // Default current page
        paginationPerPage={rowsPerPage} // Rows per page
        onChangePage={handlePageChange} // Handle page change
        onChangeRowsPerPage={handleRowsPerPageChange} // Handle rows per page change
        progressPending={loading} // Show loading spinner
      />
    </Fragment>
  );
};
export default TableProvincesComponent;
